import type { ReactNode } from 'react';
import { Simge, type SimgeAdi } from './Simge.js';

/* ---------- Kart ---------- */

export function Kart({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <section className={`kart ${className}`}>{children}</section>;
}

export function KartBaslik({ baslik, children }: { baslik: ReactNode; children?: ReactNode }) {
  return (
    <header className="kart-baslik">
      <h2>{baslik}</h2>
      {children && <div className="satir">{children}</div>}
    </header>
  );
}

/* ---------- Ana sayfa ölçüm kutusu ---------- */

export function Olcum({
  etiket, deger, alt, vurgu, buyuk,
}: {
  etiket: string; deger: ReactNode; alt?: ReactNode;
  vurgu?: 'olumlu' | 'uyari'; buyuk?: boolean;
}) {
  return (
    <div className="kart olcum">
      <div className="etiket">{etiket}</div>
      <div className={`deger ${vurgu ?? ''} ${buyuk ? 'buyuk' : ''}`}>{deger}</div>
      {alt && <div className="alt">{alt}</div>}
    </div>
  );
}

/* ---------- Rozet ---------- */

export type RozetTonu = 'notr' | 'olumlu' | 'uyari' | 'kritik' | 'bilgi';

export function Rozet({ ton = 'notr', sade, children }: { ton?: RozetTonu; sade?: boolean; children: ReactNode }) {
  return <span className={`rozet ${ton} ${sade ? 'sade' : ''}`}>{children}</span>;
}

/* ---------- Boş durum ---------- */

export function BosDurum({
  simge = 'bilgi', baslik, aciklama, children,
}: { simge?: SimgeAdi; baslik: string; aciklama?: string; children?: ReactNode }) {
  return (
    <div className="bos-durum">
      <Simge ad={simge} boyut={30} className="simge" />
      <h3>{baslik}</h3>
      {aciklama && <p>{aciklama}</p>}
      {children}
    </div>
  );
}

/* ---------- Yükleniyor ---------- */

export function Yukleniyor({ satir = 4 }: { satir?: number }) {
  return (
    <div className="sutun" aria-busy="true" aria-label="Yükleniyor">
      {Array.from({ length: satir }, (_, i) => (
        <div key={i} className="iskelet" style={{ height: i === 0 ? 34 : 46 }} />
      ))}
    </div>
  );
}

/* ---------- Uyarı şeridi ---------- */

export function UyariSerit({
  ton = 'notr', baslik, children, eylem,
}: { ton?: 'notr' | 'olumlu' | 'uyari' | 'kritik'; baslik?: ReactNode; children?: ReactNode; eylem?: ReactNode }) {
  const simge: SimgeAdi = ton === 'olumlu' ? 'onay' : ton === 'notr' ? 'bilgi' : 'uyari';
  return (
    <div className={`uyari-serit ${ton}`} role={ton === 'kritik' ? 'alert' : undefined}>
      <Simge ad={simge} className="simge" />
      <div className="esnek">
        {baslik && <div className="baslik">{baslik}</div>}
        {children && <div className="aciklama">{children}</div>}
      </div>
      {eylem}
    </div>
  );
}

/* ---------- Hata gösterimi ---------- */

export function HataKutusu({ hata, yenile }: { hata: { message: string }; yenile?: () => void }) {
  return (
    <UyariSerit
      ton="kritik"
      baslik="İşlem tamamlanamadı"
      eylem={yenile && <button className="btn btn-ikincil btn-kucuk" onClick={yenile}>Tekrar dene</button>}
    >
      {hata.message}
    </UyariSerit>
  );
}

/* ---------- Sayfa başlığı ---------- */

export function SayfaBaslik({
  baslik, alt, children,
}: { baslik: string; alt?: ReactNode; children?: ReactNode }) {
  return (
    <div className="sayfa-baslik">
      <div>
        <h1>{baslik}</h1>
        {alt && <div className="alt">{alt}</div>}
      </div>
      {children && <div className="eylemler">{children}</div>}
    </div>
  );
}
